export class Claim {
  id!: number;

  // Policy information
  policyNumber!: string;
  policyContractNumber!: string;
  policyProductTypeId!: number;
  policyProductVersionId!: number;
  policyUniqueIdentifier!: string;
  policyHolderCodeId!: string;
  policyBrokerCodeId!: string;

  // Claim information
  uniqueIdentifier!: string;
  assignedTo!: string;
  claimNumber!: string;
  claimDefinitionId!: number;
  claimDefinitionVersionCode!: string;
  claimTypeId!: number; //FK, lookup
  priorityId!: number; //FK, lookup
  reportedViaId!: number; //FK, lookup
  settlementStatusId!: number; //FK, lookup
  statusId!: number; //FK, lookup
  subStatusId!: number; //FK, lookup

  incidentDate!: Date;
  incidentAddressId!: number; //FK
  incidentLocation!: string;

  claimResolvedAt!: Date;
  firstSettlementProposalAt!: Date;

  isSensitive!: boolean;
  isArchived!: boolean;
  isProtected!: boolean;
  isFraudCheckPerformed!: boolean;

  settlementAmount!: number;
  reservedAmount!: number;

  language!: string;
  summary!: string;

  branchId!: number; //FK

  customerId!: number;

  externalReference1!: string;
  externalReference2!: string;

  createdAt!: Date;
  createdBy!: string;
  modifiedAt!: Date;
  modifiedBy!: string;

  //Calculated claim data
  status!: string;
  subStatus!:string;
  settlementStatus!:string;
  claimType!: string;
  priority!: string; 
  reportedVia!: string;
  brokerName!: string;


  constructor(data?: any) {
      if (data) {
          this.id = data.id;

          this.policyNumber = data.policyNumber;
          this.policyContractNumber = data.policyContractNumber;
          this.policyProductTypeId = data.policyProductTypeId;
          this.policyProductVersionId = data.policyProductVersionId;
          this.policyUniqueIdentifier = data.policyUniqueIdentifier;
          this.policyHolderCodeId = data.policyHolderCodeId;
          this.policyBrokerCodeId = data.policyBrokerCodeId;

          this.uniqueIdentifier = data.uniqueIdentifier;
          this.assignedTo = data.assignedTo;
          this.claimDefinitionId = data.claimDefinitionId;
          this.claimDefinitionVersionCode = data.claimDefinitionVersionCode;
          this.claimTypeId = data.claimTypeId;
          this.priorityId = data.priorityId;
          this.reportedViaId = data.reportedViaId;
          this.settlementStatusId = data.settlementStatusId;
          this.claimNumber = data.claimNumber;

          this.claimResolvedAt = data.claimResolvedAt;
          this.firstSettlementProposalAt = data.firstSettlementProposalAt;

          this.incidentDate = data.incidentDate;
          this.incidentLocation = data.incidentLocation;
          this.incidentAddressId = data.incidentAddressId;

          this.statusId = data.statusId;
          this.subStatusId = data.subStatusId;

          this.isSensitive = data.isSensitive;
          this.isArchived = data.isArchived;
          this.isProtected = data.isProtected;
          this.isFraudCheckPerformed = data.isFraudCheckPerformed;

          this.settlementAmount = data.settlementAmount;
          this.reservedAmount = data.reservedAmount;

          this.language = data.language;
          this.summary = data.summary;

          this.createdAt = data.createdAt;
          this.createdBy = data.createdBy;
          this.modifiedAt = data.modifiedAt;
          this.modifiedBy = data.modifiedBy;

          this.customerId = data.customerId;
          
          this.branchId = data.branchId;

          this.externalReference1 = data.externalReference1;
          this.externalReference2 = data.externalReference2;
      }
  }  
}